// extracted by mini-css-extract-plugin
export default {"content":"PokerConfigurationPlaceholder_content__9Iq9y"};